import { ApplicationConfig, provideAppInitializer, provideBrowserGlobalErrorListeners } from "@angular/core";
import { provideRouter } from "@angular/router";
import dxConfig from "devextreme/core/config";

import { routes } from "./app.routes";
import { Environment } from "../environment";
import { AuthenticatedGuard } from "./pages/authenticated-guard";
import { UnauthenticatedGuard } from "./pages/unauthenticated-guard";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAppInitializer(appInitializer),
    AuthenticatedGuard,
    UnauthenticatedGuard,
  ],
};

function appInitializer() {
  dxConfig({
    licenseKey: Environment.DxLicenseKey,
  });
}
